export const calculateStyle = (color) => ({
  '--iconSvgColor': color,
});
